import { InjectionToken } from '@angular/core';
import { type ServiceToolsMapItem } from './service-tools-map-item.model';
import { type ServiceToolBase } from './service-tool-base.model';

type ServiceToolsMap = ServiceToolsMapItem<ServiceToolBase>[];

export const SERVICE_TOOLS_MAP = new InjectionToken<ServiceToolsMap>('service tools map');
